import { render } from "./video-loader.vue?vue&type=template&id=c72a816c&scoped=true"
const script = {}

import "./video-loader.vue?vue&type=style&index=0&id=c72a816c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c72a816c"]])

export default __exports__